module.exports = __webpack_public_path__ + "img/40-safari.1456d711.svg";